import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { AsyncPipe, DatePipe } from '@angular/common';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { BookingService, OnlineBookingState } from '@beautyapp/core';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import {
  OnlineBookingModalComponent
} from '../../../../../shared/src/lib/components/online-booking-modal/online-booking-modal.component';
import { Store } from '@ngxs/store';
import { AuthState, NotificationGranted } from '@beautyapp/auth';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzButtonComponent } from 'ng-zorro-antd/button';

@Component({
  selector: 'beautyapp-notification-panel',
  templateUrl: './notification-panel.component.html',
  styleUrls: ['./notification-panel.component.scss'],
  imports: [
    NzTabsModule,
    NzTypographyModule,
    NzDividerModule,
    NzGridModule,
    NzBadgeModule,
    NzTagModule,
    DatePipe,
    AsyncPipe,
    NzSpaceModule,
    NzAlertComponent,
    NzButtonComponent,
    TranslateModule
]
})
export class NotificationPanelComponent implements OnInit, OnDestroy {

  bookingService: BookingService = inject(BookingService);
  modalService: NzModalService = inject(NzModalService);
  translateService: TranslateService = inject(TranslateService);
  store: Store = inject(Store);

  tabs = [
    {
      id: 'bookinghub-notification',
      title: 'Bookinghub ჩაწერები'
    },
    {
      id: 'notification',
      title: 'შეტყობინებები'
    }
  ];

  onlineBookings$ = this.bookingService.onlineBookings();
  notificationGranted = this.store.selectSignal(AuthState.getNotificationGranted);

  notificationPermission = signal(Notification.permission);

  sub$: Subject<any> = new Subject<any>();

  ngOnInit(): void {
    // Subscribe to real-time notifications to refresh the list
    this.subscribeToNotifications();
  }

  /**
   * Subscribe to NGXS state for online booking notifications to refresh the list
   */
  private subscribeToNotifications(): void {
    this.store.select(OnlineBookingState.getLastNotification)
      .pipe(takeUntil(this.sub$))
      .subscribe(notification => {
        if (notification) {
          console.log('[NotificationPanel] Refreshing bookings list from NGXS');
          // Refresh the online bookings list when notification arrives
          this.onlineBookings$ = this.bookingService.onlineBookings();
        }
      });
  }

  handleEventClick(booking: any) {

    const bookingDate = new Date(booking.bookingDate);
    const startTime = booking.startTime.split(':');

    bookingDate.setHours(startTime[0], startTime[1]);

    const endTime = booking.endTime.split(':');
    const endDate = new Date(booking.bookingDate);
    endDate.setHours(endTime[0], endTime[1]);

    const modal = this.modalService.create({
      nzClosable: false,
      nzMaskClosable: false,
      nzTitle: this.translateService.instant('calendar.planVisit'),
      nzContent: OnlineBookingModalComponent,
      nzWidth: '1100px',
      nzStyle: { top: '0px' },
      nzBodyStyle: { padding: '0' },
      nzData: {
        id: booking.id
      }
    });
    modal.afterClose.subscribe((res) => {
      this.onlineBookings$ = this.bookingService.onlineBookings();
    });
  }

  ngOnDestroy() {
    this.sub$.next(null);
    this.sub$.complete();
  }

  handleNotificationPermission() {
    if (Notification.permission === 'granted') {
    } else if (Notification.permission !== 'denied') {

      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          this.store.dispatch(new NotificationGranted(true));
        }
      });
    }
    if (Notification.permission === 'denied') {
      console.error('Notification permission denied.');
      alert('You have blocked notifications. Please enable notifications in your browser settings to receive updates.');
    }
  }
}
